module.exports = __webpack_public_path__ + "img/win10.dff5e0ca.png";